import common from './common.json';
import knowledgeBases from './knowledgeBases.json';
import assistants from './assistants.json';
import tools from './tools.json';
import inboxes from './inboxes.json';
import pendingFaqs from './pendingFaqs.json';

export default {
  PILOT: {
    ...common.PILOT,
    ...knowledgeBases,
    ...assistants,
    ...tools,
    ...inboxes,
    ...pendingFaqs,
  },
};
